export interface ServerError {
  status: HttpStatusCode;
  detail: string;
  source?: {
    pointer: string;
  };
  title?: string;
  code?: string;
}

export enum HttpStatusCode {
  OK = 200,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
  CONFLICT = 409,
  NO_CONTENT = 204,
}

export type ErrorCodes = { code: string; detail: string; status: number }[] | [];

export class HttpErrorResponse extends Error {
  errors: ServerError[];
  response: Response;

  constructor(response: Response, errors: ServerError[] = [], ...args: []) {
    super(...args);
    this.response = response;
    this.errors = errors;
  }
}

export class HttpConflictErrorResponse extends HttpErrorResponse {}
